import { useEffect, useRef } from "react";
import classNames from "classnames";
import Icon from "../Icon";
import { dataPagination } from "./Pagination/PaginationButtons";
import { useSelector } from "react-redux";

const DataTable = ({
  columns,
  data,
  perPage,
  currentPage,
  requestSort,
  getClassNamesFor,
  darkModeStatus,
  tdClassName,
  height, // vertical scroll height
  stickyHeader = false, // enable/disable sticky header
}) => {
  const paginatedData =
    perPage && perPage > 0 ? dataPagination(data, currentPage, perPage) : data;
  const hasItems = paginatedData?.length === 0;

  const tableRef = useRef(null);
  useEffect(() => {
    const table = tableRef.current;
    if (!table) return;

    const stickyHeaders = table.querySelectorAll(
      "thead th[data-sticky='left']"
    );
    const stickyCells = table.querySelectorAll("tbody td[data-sticky='left']");

    let leftOffset = -20;

    stickyHeaders.forEach((th, index) => {
      const width = th.offsetWidth;

      th.style.left = `${leftOffset}px`;

      stickyCells.forEach((td, tdIndex) => {
        if (tdIndex % stickyHeaders.length === index) {
          td.style.left = `${leftOffset}px`;
        }
      });

      leftOffset += width;
    });
  }, [columns, data]);

  return (
    <>
      <div
        className={classNames(
          "table-responsive table-scroll-x",
          tdClassName,
          stickyHeader && "table-fixed-wrapper"
        )}
        style={{ maxHeight: height, overflowY: "auto" }}
      >
        {hasItems  ? (
          <div className="d-flex flex-column align-items-center text-muted">
            <Icon
              iconName="Rabbit"
              width="52"
              height="52"
              className="mb-2 opacity-50"
            />
            <div className="fw-semibold fs-5">No records available!</div>
            <div className="fs-6">
              There are currently no items to display. Please try again later.
            </div>
          </div>
        ) : (
          <table ref={tableRef} className="table table-modern table-hover">
            <thead>
              <tr>
                {columns.map((col) => (
                  <th
                    key={col.key}
                    data-sticky={col.sticky === "left" ? "left" : undefined}
                    className={classNames({
                      "cursor-pointer text-decoration-underline": col.sortable,
                      "text-center": col.isCenter,
                    })}
                    onClick={
                      col.sortable ? () => requestSort(col.accessor || col.key) : undefined
                    }
                  >
                    {col.label}{" "}
                    {col.sortable && (
                      <Icon
                        className={getClassNamesFor(col.accessor || col.key)}
                        iconName="ListFilter"
                        width="16"
                      />
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData?.map((item, index) => (
                <tr key={index} className={classNames({"table-light-aqua no-stripe": item.STATUS === 'not-known'})}>
                  {columns.map((col) => (
                    <td
                      key={col.key}
                      data-sticky={col.sticky === "left" ? "left" : undefined}
                      className={classNames({
                        "text-center": col.isCenter,
                      })}
                    >
                      {col.render ? col.render(item) : item[col.accessor || col.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default DataTable;